export default __webpack_public_path__ + "static/media/roobert-regular-webfont.70c7a876.woff2";